export default __webpack_public_path__ + "static/media/Medium2.1151d158.svg";